module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAABVklEQVQ4T43TP0iWURTH8Y+YhGC7gkMECrZFkouDkzWUiyAtjg1BDf4brNF/i0K1NNQetIhOOohDQv8hqEUDR0FElyA0ReXAfel9Lz4+71me595z7veec373NLjcFnEL14vCGgocbRjFePIvYQZf8/iLAA/xDpt4gz8YRi9eYKQakgP6sYpHeJvddhvfMIdnFV8OOMM8JgpK68M6WrEbMdWAO/ic7V3EOUiXzOaAQbxHY4kyn/AzlVmTwQBCtjJAKBGZPskzuIuVOkr4gTWM5YAHWK4DEOlv4HEOiMfSia6SHrzCUzThpKJCB7bQgy8lgCv4iHvYD0BF24Wqp1vC+O8OQOg5iQ9oTz04SiFX0/cEx2hO67/p/2WlhJi4G4j0wgLwD9eqDpyiJUvtV9E0TmEHr9OBm4i9eGw1VgSYxvPU1D1s4zu66wVEXAzVEA7xG/cRw1Zj5yk5P63zjxRQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/msg.png
// module id = QqtN
// module chunks = 21